import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Injectable,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { AppSettingsService, AzureWrapperServices } from '@nx-fe/services';
import * as atlas from 'azure-maps-control';
import { MapStyle } from '../models';
import { TranslateService } from '@ngx-translate/core';

type MapOptions = atlas.ServiceOptions &
  atlas.StyleOptions &
  atlas.UserInteractionOptions &
  (atlas.CameraOptions | atlas.CameraBoundsOptions);

@Injectable({ providedIn: 'root' })
@Directive({
  selector: '[xsMap]',
})
export class MapDirective implements AfterViewInit, OnDestroy {
  private _map: atlas.Map;

  @Input()
  protected options?: MapOptions;

  @Input()
  public style = MapStyle.NIGHT;

  @Output()
  public onMapReady = new EventEmitter<atlas.Map>();

  constructor(
    private _element: ElementRef,
    private _appSettingsService: AppSettingsService,
    private _azureWrapperService: AzureWrapperServices,
    private _translateService: TranslateService
  ) {}

  public ngOnDestroy(): void {
    this._map?.dispose();
  }

  public ngAfterViewInit(): void {
    this._appSettingsService.loadAzureKey().then(resp => {
      const renderLanguage = this._translateService.currentLang;
      this._initMap(resp.azureApiKey, resp.azureClientId, renderLanguage);
    });
  }

  private _initMap(azureApiKey: string, azureClientId: string, language = 'en-US') {
    this._map = this._azureWrapperService.map(this._element.nativeElement, {
      language: language,
      style: this.style,
      authOptions: azureClientId ? 
      {
        authType:  atlas.AuthenticationType.sas,
        sasToken: azureApiKey,
        clientId: azureClientId,
      } 
      : { authType:  atlas.AuthenticationType.subscriptionKey, subscriptionKey: azureApiKey },
      disableTelemetry: true,
      showFeedbackLink: false,
      showLogo: false,
      autoResize: false,
      /* Setting max pitch Min Value greater than 0 , Since we cant turn of pitch controls */
      maxPitch: Number.MIN_VALUE,
      // Setting max zoom level, anything further map details are not visible
      maxZoom: 21,
      ...this.options,
    });

    this._map.events.add('ready', () => {
      this.onMapReady.emit(this._map);
    });
  }
}
